import React, { useState, useEffect } from 'react';
import { Button, Modal, Spinner } from "react-bootstrap";
import { Add, DeleteForever, LinkTwoTone, Videocam, PictureAsPdf } from '@material-ui/icons';

import incident_manager from '../api/incident'

const IncidentMedicalLinkPopup = ({ visible, hidePopup, generateCallback }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [incidentLinks, setIncidentLinks] = useState([]);
    const [copiedIndex, setCopiedIndex] = useState(null);

    useEffect(async () => {
        if (visible) {
            setIsLoading(true);
            const links = await generateCallback();
            setIncidentLinks(links)
            setIsLoading(false);
        }
    }, [visible]);

    return (
        <Modal show={visible} onHide={hidePopup}>
            <Modal.Header closeButton>
                <Modal.Title>Qualtrics survey URLs</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    { isLoading
                    ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "150px" }}>
                            <Spinner animation="border" variant="primary" />
                        </div>
                    )
                    : (
                        <>
                            {incidentLinks.length > 0 ? (
                            <table className="table table-striped table-sm">
                                <thead>
                                <tr>
                                    <th>Recipient</th>
                                    <th>Link</th>
                                </tr>
                                </thead>
                                <tbody>
                                {incidentLinks.map((link, idx) => (
                                    <tr key={idx}>
                                        <td>{link.recipient}</td>
                                        <td>
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={() => {
                                                    navigator.clipboard.writeText(link.url)
                                                    setCopiedIndex(idx);
                                                    setTimeout(() => setCopiedIndex(null), 2500);
                                                }}
                                            >
                                                {copiedIndex === idx ? "Copied!" : "Copy Link"}
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            ) : (
                            <p>No links available.</p>
                            )}
                        </>
                    )}
                </div>
            </Modal.Body>
        </Modal>    
    );
}

const IncidentMedicalInfo = ({ incidentId }) => {
    let [popupVisible, setPopupVisible] = useState(false)

    return (
        <>
            <h3 key='medicalInfo'>Medical surveillance</h3>
            <div className='newIncidentMediaContainer' style={{marginBottom: 30}}>
                <span className='btn btn-success' onClick={()=>setPopupVisible(true)}><Add/>Generate Qualtrics URLs</span>
                <IncidentMedicalLinkPopup
                    hidePopup={() => setPopupVisible(false)} 
                    visible={popupVisible} 
                    generateCallback={() => incident_manager.generate_qualtrics_links(incidentId)}
                />
            </div>
        </>
    );
}

export default IncidentMedicalInfo;